// TM-1000001816: HE-Modul (Integration Connection Registry) — Config-Page,
// Object-Pages, Object-Components und Tabellen-Widgets deklarieren. Struktur
// gespiegelt vom IN-Modul.
import {NgModule} from '@angular/core';
import {CoreModule} from '../../core/core.module';
import {HE_TEST_PROVIDERS} from './test/he-test-definition';
import {HE_ENTITY_PROVIDER} from './he.entity-provider';
import {HeConfigPage} from './page/he-config/he-config.page';
import {
    HeSftpConnectionObjectPage
} from './page/object/he-sftp-connection-object-page/he-sftp-connection-object.page';
import {
    HeFtpConnectionObjectPage
} from './page/object/he-ftp-connection-object-page/he-ftp-connection-object.page';
import {
    HeSftpConnectionObjectComponent
} from './component/object-components/he-sftp-connection-object-component/he-sftp-connection-object.component';
import {
    HeFtpConnectionObjectComponent
} from './component/object-components/he-ftp-connection-object-component/he-ftp-connection-object.component';
import {HeSftpConnectionTableComponent} from './component/widgets/he-sftp-connection-table.component';
import {HeFtpConnectionTableComponent} from './component/widgets/he-ftp-connection-table.component';

@NgModule({
  declarations: [
    // TM-1000001816: Pages
    HeConfigPage,
    HeSftpConnectionObjectPage,
    HeFtpConnectionObjectPage,
    // TM-1000001816: Object-Components + Tabellen-Widgets
    HeSftpConnectionObjectComponent,
    HeFtpConnectionObjectComponent,
    HeSftpConnectionTableComponent,
    HeFtpConnectionTableComponent,
  ],
  exports: [
    HeConfigPage,
    HeSftpConnectionObjectPage,
    HeFtpConnectionObjectPage,
    HeSftpConnectionObjectComponent,
    HeFtpConnectionObjectComponent,
    HeSftpConnectionTableComponent,
    HeFtpConnectionTableComponent,
  ],
  imports: [
    CoreModule,

  ],
  providers: [HE_ENTITY_PROVIDER, HE_TEST_PROVIDERS]
})
export class HeModule { }
